import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
} from '@mui/material';
import {
  Email,
  Phone,
  LinkedIn,
  Twitter,
  Facebook,
} from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const quickLinks = [
    { text: 'Home', path: '/' },
    { text: 'Services', path: '/services' },
    { text: 'Careers', path: '/careers' },
    { text: 'Contact', path: '/contact' },
  ];

  return (
    <Box
      component="footer"
      sx={
        {
          bgcolor: 'primary.main',
          color: 'white',
          py: 6,
          mt: 'auto',
        }
      }
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              VinPriv Talent Solutions
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              "Delivering the Right Talent, at the Right Time, for the Right Results."
            </Typography>
            <Typography variant="body2">
              Founded in February 2024, we specialize in IT Staffing and Talent Solutions
              with expertise in SAP, Power BI, and Microsoft Azure.
            </Typography>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            {quickLinks.map((link) => (
              <Link
                key={link.text}
                component={RouterLink}
                to={link.path}
                color="inherit"
                underline="hover"
                display="block"
                sx={{ mb: 1 }}
              >
                {link.text}
              </Link>
            ))}
          </Grid>
          
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom>
              Our Expertise
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>SAP Solutions</Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>Power BI Analytics</Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>Microsoft Azure</Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>SAP Analytics Cloud</Typography>
          </Grid>
          
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom>
              Contact Info
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Email sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2">hr@vinpriv.com</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Phone sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2">+91 91828 74879</Typography>
            </Box>
            <Box>
              <IconButton color="inherit" size="small">
                <LinkedIn />
              </IconButton>
              <IconButton color="inherit" size="small">
                <Twitter />
              </IconButton>
              <IconButton color="inherit" size="small">
                <Facebook />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 3, bgcolor: 'rgba(255,255,255,0.2)' }} />
        
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2">
            © 2024 VinPriv Talent Solutions Private Limited. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;